/**
 * WordPress dependencies
 */
import { useRefEffect } from '@wordpress/compose';
/**
 * Internal dependencies
 */

import { toHTMLString } from '../to-html-string';
import { isCollapsed } from '../is-collapsed';
import { slice } from '../slice';
import { getTextContent } from '../get-text-content';
export function useCopyHandler(_ref) {
  var record = _ref.record,
      multilineTag = _ref.multilineTag,
      preserveWhiteSpace = _ref.preserveWhiteSpace;
  return useRefEffect(function (element) {
    function onCopy(event) {
      if (isCollapsed(record.current) || !element.contains(element.ownerDocument.activeElement)) {
        return;
      }

      var selectedRecord = slice(record.current);
      var plainText = getTextContent(selectedRecord);
      var html = toHTMLString({
        value: selectedRecord,
        multilineTag: multilineTag,
        preserveWhiteSpace: preserveWhiteSpace
      });
      event.clipboardData.setData('text/plain', plainText);
      event.clipboardData.setData('text/html', html);
      event.clipboardData.setData('rich-text', 'true');
      event.preventDefault();
    }

    element.addEventListener('copy', onCopy);
    return function () {
      element.removeEventListener('copy', onCopy);
    };
  }, [record, multilineTag, preserveWhiteSpace]);
}
//# sourceMappingURL=use-copy-handler.js.map